import "~/postcss/index.css";
import 'what-input';
import 'rails-plus/es6/bundles/modernizr';

import Flips          from 'rails-plus/es6/modules/Flips';

import $               from 'jquery';
import Rails           from '@rails/ujs';
import Turbolinks      from 'turbolinks';
import { Application } from '@hotwired/stimulus';
import { registerControllers } from "stimulus-vite-helpers";
const controllers = import.meta.glob("~/controllers/*_controller.js", { eager: true });

import AutosizedTextareas         from '~/modules/AutosizedTextareas';
import SwipeGallery               from '~/modules/SwipeGallery';
import FlashItems                 from '~/modules/FlashItems';
import MicroModals                from '~/modules/MicroModals';
import PageEvent                  from '~/modules/PageEvent';
import Tooltips                   from '~/modules/Tooltips';
import ujs                        from '~/modules/ujs';

window.$ = $;
window.jQuery = $;
window.Rails = Rails;
window.PageEvent = PageEvent;
window.ujs = ujs;

AutosizedTextareas.start();
FlashItems.start();
SwipeGallery.start();
Flips.start();
MicroModals.start();
Rails.start();
Tooltips.start();
Turbolinks.start();

PageEvent.delegate('turbolinks:load', 'page:load');

const application = Application.start();
registerControllers(application, controllers);

if (document.readyState !== 'loading') {
  const event = document.createEvent('Event');
  event.initEvent('DOMContentLoaded', true, true);
  window.document.dispatchEvent(event);
}
